/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TravelineVatDto } from './traveline-vat-dto';
import {
    TravelineVatDtoFromJSON,
    TravelineVatDtoFromJSONTyped,
    TravelineVatDtoToJSON,
    TravelineVatDtoToJSONTyped,
} from './traveline-vat-dto';

/**
 * The rate plan of the accommodation property
 * @export
 * @interface TravelineRatePlanInfoDto
 */
export interface TravelineRatePlanInfoDto {
    /**
     * Rate plan ID
     * @type {string}
     * @memberof TravelineRatePlanInfoDto
     */
    id: string;
    /**
     * Rate plan name
     * @type {string}
     * @memberof TravelineRatePlanInfoDto
     */
    name: string;
    /**
     * Rate plan description, may contain HTML tags
     * @type {string}
     * @memberof TravelineRatePlanInfoDto
     */
    description?: string | null;
    /**
     * (Planned) Rate plan currency
     * @type {string}
     * @memberof TravelineRatePlanInfoDto
     */
    currency: string;
    /**
     * Stay available with children only
     * @type {boolean}
     * @memberof TravelineRatePlanInfoDto
     */
    isStayWithChildrenOnly: boolean;
    /**
     * Cancellation rule ID
     * @type {string}
     * @memberof TravelineRatePlanInfoDto
     */
    cancellationRuleId: string;
    /**
     * Early check-in and late check-out rule ID.<br />
     * Null if rate plan does not allow additional accommodation.
     * @type {string}
     * @memberof TravelineRatePlanInfoDto
     */
    extraStayRuleId?: string | null;
    /**
     * 
     * @type {TravelineVatDto}
     * @memberof TravelineRatePlanInfoDto
     */
    vat?: TravelineVatDto;
}

/**
 * Check if a given object implements the TravelineRatePlanInfoDto interface.
 */
export function instanceOfTravelineRatePlanInfoDto(value: object): value is TravelineRatePlanInfoDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('isStayWithChildrenOnly' in value) || value['isStayWithChildrenOnly'] === undefined) return false;
    if (!('cancellationRuleId' in value) || value['cancellationRuleId'] === undefined) return false;
    return true;
}

export function TravelineRatePlanInfoDtoFromJSON(json: any): TravelineRatePlanInfoDto {
    return TravelineRatePlanInfoDtoFromJSONTyped(json, false);
}

export function TravelineRatePlanInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineRatePlanInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'currency': json['currency'],
        'isStayWithChildrenOnly': json['isStayWithChildrenOnly'],
        'cancellationRuleId': json['cancellationRuleId'],
        'extraStayRuleId': json['extraStayRuleId'] == null ? undefined : json['extraStayRuleId'],
        'vat': json['vat'] == null ? undefined : TravelineVatDtoFromJSON(json['vat']),
    };
}

  export function TravelineRatePlanInfoDtoToJSON(json: any): TravelineRatePlanInfoDto {
      return TravelineRatePlanInfoDtoToJSONTyped(json, false);
  }

  export function TravelineRatePlanInfoDtoToJSONTyped(value?: TravelineRatePlanInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'currency': value['currency'],
        'isStayWithChildrenOnly': value['isStayWithChildrenOnly'],
        'cancellationRuleId': value['cancellationRuleId'],
        'extraStayRuleId': value['extraStayRuleId'],
        'vat': TravelineVatDtoToJSON(value['vat']),
    };
}

